import React from "react";
import Link from "next/link";

export default React.memo(function BreadCrumbs({ links = [] }) {
  return (
    <nav className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ol className="breadcrumb mb-0 font-size-xs text-gray-400">
              {links.map(({ url, name }, index) => (
                <li key={index} className="breadcrumb-item">
                  <Link href={url}>
                    <a className="text-gray-400">{name}</a>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </nav>
  );
});
